import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '@catawiki/cata-style';
import { RFC4646Locale } from '@catawiki/locale';
import { ABOUT_US_PATH, CAREERS_PATH, EXPERTS_PATH, IMPERSSUM_PATH, LASTDODO_PATH, PARTNERING_PATH, PRESS_PATH, } from '../paths';
import { FooterColumn } from '../shared/FooterColumn';
import { useLocale } from '../../../../hooks/useLocale';
export const About = ({ showPress, showCollectors }) => {
    const { t } = useI18n();
    const locale = useLocale();
    const columnItems = [
        { content: t('about'), link: ABOUT_US_PATH(locale) },
        { content: t('footer_link_our_experts'), link: EXPERTS_PATH(locale) },
        { content: t('careers'), link: CAREERS_PATH },
        ...(showPress
            ? [{ content: t('press_link'), link: PRESS_PATH(locale) }]
            : []),
        {
            content: t('footer_link_partnering_with_catawiki'),
            link: PARTNERING_PATH(locale),
        },
        ...(showCollectors
            ? [{ content: t('collectors_platform'), link: LASTDODO_PATH }]
            : []),
        ...(locale === RFC4646Locale.GERMAN
            ? [{ content: t('impressum'), link: IMPERSSUM_PATH(locale) }]
            : []),
    ];
    return _jsx(FooterColumn, { title: t('about'), items: columnItems });
};
//# sourceMappingURL=About.js.map